define('plugin/kiosk/model/KioskModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Back to site model
     *
     * @class BackToSiteModel
     */
    return BaseModel.extend({

        url: '/ext/kiosk/',

        defaults: {

        },

        clear: function (handler) {
            var url = this.baseUrl + '/ext/kiosk/clear/';
            Backbone.ajax(url, {
                success: _.bind(function (data) {
                    console.log(data);
                    this.set(data);
                    this.trigger('sync');
                    if(handler){
                        handler();
                    }
                }, this)
            });
        },

    });

});
